export default __webpack_public_path__ + "static/media/logomin.a8b362e6.svg";